// extracted by mini-css-extract-plugin
export default {"ETF":"FundVestTag_ETF__bDOqq","MF":"FundVestTag_MF__eTUQv"};